var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.44739 11.0868c-.39469-2.1884 2.37546-2.18473 3.72681-2.78117.7615-.3382 2.9176-2.06073 2.2705-3.28514-.3572.0044-3.9263-.04182-5.01132-.00807-1.34399.03961-2.36079 1.12317-2.39234 2.27715-.05502 1.98297-.04108 7.15063-.03448 7.30983 0 .0058.96325.074 1.85826-.7792 1.07035-1.0219-.28244-1.9851-.41743-2.7334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0641 6.62984c0-.68153-.6184-1.60223-2.1671-1.60223-.7028 0-1.3102-.0154-2.374-.0154-.3785.68226-.7064 1.6433-.7321 3.05625-.0206 1.05495.3301 2.58304 1.1855 2.84494 1.6932.5194 4.0921-.3968 4.0921-1.80907.003-.20981-.0044-1.49951-.0044-2.47449z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0065 13.4321c-.0205.011-.044.0242-.0646.0389-.9522 1.0447-1.399 2.5009-3.0181 2.5413-2.0666.0521-3.7385-1.7541-5.844-.4718-1.31242.7968-2.16562 1.8612-2.20376 3.4561-.01394.0162 2.40556-.0337 4.20436-.0477.4673-.0036.9288.0037 1.4034-.0036 1.9588-.0022 3.3255.0044 3.3284.0044 1.3624 0 2.1422-1.3807 2.1422-2.1605.0528-1.8532.0763-1.3095.0528-3.0732-.0007-.0953-.0007-.19-.0007-.2839z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiver);
export default __webpack_public_path__ + "static/media/river.24cb7b1e55154ec2e899823a39b62d04.svg";
export { ForwardRef as ReactComponent };